import request from '@/utils/request'


//查询
export function fechListWorkers(data) {
  return request({
    url: '/admin/worker/qlWorker',
    method: 'post',
    data: data
  })
}

//查询店铺所有员工
export function selectAllWorkerInfo(params) {
  return request({
    url: '/admin/worker/selectAll',
    method: 'get',
    params: params
  })
}
//获取合同列表
export function workerContract(params) {
  return request({
    url: '/admin/worker/worker/contract',
    method: 'get',
    params: params
  })
}
//更新薪资模板
export function updateWorkerCommissonTemplate(data) {
  return request({
    url: '/admin/worker/updateWorkerCommissonTemplate',
    method: 'post',
    data: data
  })
}


//创建
export function inputWorker(data) {
  return request({
    url: '/admin/worker/inputWorker',
    method: 'post',
    data: data
  })
}
// //解雇
// export function fileWorker(params) {
//   return request({
//     url: '/admin/worker/fileWorker',
//     method: 'get',
//     params: params
//   })
// }

//解雇
export function fireWorker(data) {
  return request({
    url: '/admin/worker/fireWorker',
    method:'post',
    data:data
  })
}

//删除
export function delWorker(params) {
  return request({
    url: '/admin/worker/delWorker',
    method: 'get',
    params: params
  })
}

//聘用
export function employWorker(params) {
    return request({
        url: '/admin/worker/employWorker',
        method: 'get',
        params: params
    })
}
//回雇
export function rehireWorker(params) {
  return request({
    url: '/admin/worker/rehireWorker',
    method: 'get',
    params: params
  })
}

//上传资料
export function addFile(data) {
  return request({
    url: '/admin/worker/addFile',
    method:'post',
    data:data
  })
}

//员工资料
export function viewFile(data) {
  return request({
    url: '/admin/worker/viewFile',
    method:'post',
    data:data
  })
}

//删除资料
export function deleteFile(data) {
  return request({
    url: '/admin/worker/deleteFile',
    method:'post',
    data:data
  })
}

//修改合同时间
export function updateAgreementTime(params) {
  return request({
    url: '/admin/worker/updateAgreementTime',
    method: 'get',
    params: params
  })
}

//修改员工信息
export function updateWorkersInfo(data) {
  return request({
    url: '/admin/worker/updateWorkersInfo',
    method: 'post',
    data: data
  })
}

//解聘跟踪
export function createWorkerFollow(data) {
  return request({
    url: '/admin/worker/createWorkerFollow',
    method:'post',
    data:data
  })
}

//解聘跟踪历史
export function viewWorkerFollow(data) {
  return request({
    url: '/admin/worker/viewWorkerFollow',
    method:'post',
    data:data
  })
}

// 上传入职合同
export function uploadContract(data) {
  return request({
    url: '/admin/worker/worker/contract',
    method:'post',
    data:data
  })
}

//回雇
export function resumeWorker(params) {
  return request({
    url: '/admin/worker/worker/resume',
    method: 'put',
    params: params
  })
}


// WEBPACK FOOTER //
// ./src/api/StoreWorkers.js